import { useState } from "react";
import EformApiClient from "../../api/EformsApi";
import { DEBUG, DEMO } from '../../api/settings'
import { FormStateValues } from "../../interfaces/Form/State";
import {
  normalizeValuesForSubmit,
  getFileIDsFromData, getFilesData
} from "../../utils/utils";
import { Error, Success } from "../../interfaces/ApiMessages";
import { EformSigner } from "./../../api/eSigner.js"
import i18n from "../../i18n";
import { useAuthenticationContext } from "../../context/AuthenticationContext";
import authStorage from "../../utils/authStorage";

const getExternalAuthHeaders = (isAuthenticated: boolean) => {
  const uuid = authStorage.getUuid();

  if (!isAuthenticated || !uuid) {
    return undefined;
  }

  return {
    "X-Auth-External-Provider": "sp-service",
    "X-Auth-External-Token": uuid,
  };
};

const Submit = (props: any) => {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { isAuthenticated } = useAuthenticationContext();


  const handleSubmit = async (formSlug: string,
                              organizationID: string,
                              values: FormStateValues,
                              shouldSign?: boolean,
                              onlySign?: boolean,
                              validSignature?: {},
                              updatePublicID?: string,
                              prevID?: string,
  ) => {

    reset();

    let signature;
    if (validSignature) {
      signature = validSignature
    }
    if (shouldSign) {
      const data = normalizeValuesForSubmit(values, props.properties);
      const attchData = getFilesData(values, props.properties)
      if (window.location.hash === "#test") {
        console.log(data)
        return
      }

      var es = new EformSigner()
      try {
        setLoading(true);

        const dataToSign = {
          data: data,
          attachments: attchData,
          metadata: {
            signature: {
              version: 2
            }
          }
        }
        if (DEMO && DEBUG) {
          signature =  {demo: 'debug'}
        } else {
          signature = await es.trySignData(JSON.stringify(dataToSign));
        }
        console.log("Signed")
      } catch (e) {
        setError(e);
        setLoading(false);
        return;
      }
      if (onlySign) {
        setLoading(false);
        setError("");
        setSuccess(Success.sign);
        return signature;
      }
    }

    if (updatePublicID) {
      sendEdit(updatePublicID, values, signature);
    } else {

      if (prevID) {
        values["npsPrev"] = prevID
      }

      send(formSlug, organizationID, values, signature);
    }
  };

  const reset = () => {
    setError("");
    setSuccess("");
    setLoading(false);
  };

  const send = (form: string,
                organizationID: string,
                values: FormStateValues,
                signature?: any) => {
    const data = normalizeValuesForSubmit(values, props.properties);
    const attachmentsIDs = getFileIDsFromData(values, props.properties);
    console.log(data, values);
    setLoading(true);

    if(DEMO && signature?.demo) {
      signature = undefined
    }
    const lang = i18n.language
    const headers = getExternalAuthHeaders(isAuthenticated);
    EformApiClient.submission.postSubmission({
      attachments: attachmentsIDs,
      data,
      form,
      organization: organizationID,
      signature
    }, lang, headers)
      .then((res) => {
        setLoading(false);
        setError("");
        setSuccess(Success.submit);
        props.formRef.current.openModal(res);
        props.formRef.current.reset();
      })
      .catch((e: any) => {
        console.log(e);
        setLoading(false);
        setError(Error.submit);
      });
  };

  const sendEdit = (publicID: string,
                    values: FormStateValues,
                    signature?: any) => {
    const data = normalizeValuesForSubmit(values, props.properties);
    const attachmentsIDs = getFileIDsFromData(values, props.properties);
    console.log(data, values);
    setLoading(true);
    if(DEMO && signature?.demo){
      signature = undefined
    }
    EformApiClient.submission.updateSubmission(publicID, {
      attachments: attachmentsIDs,
      data,
      signature
    })
      .then(() => {
        setLoading(false);
        setError("");
        setSuccess(Success.edit);
        props.formRef.current.openModal();
      })
      .catch((e: any) => {
        console.log(e);
        setLoading(false);
        setError(Error.submit);
      });
  };

  return props.children(handleSubmit, reset, error, success, isLoading);
};

export default Submit;
